module.exports = __webpack_public_path__ + "static/media/img1-1.240a078b.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/biosense/biomasa/img1-1.png
// module id = 2282
// module chunks = 3